import { SVGProps } from 'react';

export const TriangleCircleSquareXIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M14.2652 2H5.73604C3.39721 2 1.50122 3.89599 1.50122 6.23482V14.764C1.50122 17.1028 3.39721 18.9988 5.73604 18.9988H14.2652C16.604 18.9988 18.5 17.1028 18.5 14.764V6.23482C18.5 3.89599 16.604 2 14.2652 2Z'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.3982 5.50586H11.7355C11.3937 5.50586 11.1167 5.78289 11.1167 6.12462V8.78737C11.1167 9.1291 11.3937 9.40613 11.7355 9.40613H14.3982C14.7399 9.40613 15.017 9.1291 15.017 8.78737V6.12462C15.017 5.78289 14.7399 5.50586 14.3982 5.50586Z'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.53881 9.57127C7.70674 9.57127 8.65354 8.62447 8.65354 7.45653C8.65354 6.2886 7.70674 5.3418 6.53881 5.3418C5.37087 5.3418 4.42407 6.2886 4.42407 7.45653C4.42407 8.62447 5.37087 9.57127 6.53881 9.57127Z'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.2809 12.3287L4.65547 15.1164C4.53115 15.3296 4.68496 15.5973 4.93177 15.5973H8.14172C8.38698 15.5973 8.54093 15.3326 8.41978 15.1194L6.8352 12.3317C6.71338 12.1174 6.40509 12.1157 6.2809 12.3287Z'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.7687 12.3555L14.3718 15.4111'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M14.4947 12.4688L11.645 15.2957'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
